'use strict';

/**
 * @ngdoc function
 * @name myConsultApp.controller:petoverviewCtrl
 * @description
 * # petoverviewCtrl
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'petoverviewCtrl',
    function (
      $scope,
      $rootScope,
      $location,
      crumble,
      $cookieStore,
      PetsService,
      $route,
      $timeout,
      $window,
      $routeParams,
      IdentityService,
      TransactionService,
      BrowserService,
      utilities,
      MediaService,
    ) {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      $scope.crumble = crumble;
      crumble.update();

      /*
       *
       *  Scope variables
       *
       */

      $scope.QOLoverview = null;
      $scope.downloadStatus = false;
      $scope.statuses = [];
      if (typeof $routeParams.petId !== 'undefined') {
        $scope.retrieveMainPetInfo($routeParams.petId);
      }
      $scope.showDenialReason = false;
      $scope.denyReason = { denial_reason: null, notes: null };
      $scope.denialError = { denialReason: false, notes: false };

      $scope.denyReasonCopy = angular.copy($scope.denyReason);
      $scope.denialErrorCopy = angular.copy($scope.denialError);
      $scope.appDenialReasons = null;
      $scope.tempInfo = {};
      $scope.showDenialReasonOther = false;
      $scope.approveError = false;
      $scope.showApproveError = false;

      $scope.mediaFiles = { solensia: [], librela: [], cpiq: [] };

      $scope.order = 'id';
      $scope.mediaCategories = '1,2,4';
      $scope.pageSize = 100;

      /*
       *
       *  Scope methods
       *
       */

      $scope.goToPage = function (pageURL) {
        TransactionService.getTransactionsPage(pageURL).then(function (response) {
          $rootScope.petTransactions = response.transactions;
          $rootScope.petTransactionsPageData = response;
        });
      };

      $scope.getReceiptUrl = function (url) {
        var myNewTab = BrowserService.openNewTab();
        utilities.getResourceUrl(url).then(function (response) {
          $timeout(function () {
            $scope.displayErrorMsg = false;
          }, 3000);
          BrowserService.updateTabLocation(response.receipts.tokenized_receipt_url, myNewTab);
        });
      };

      $scope.filterStatus = function (id) {
        var status = $scope.statuses.filter(function (status) {
          return status.id == id;
        });
        return status;
      };

      $scope.getOwnerDetails = function (id) {
        IdentityService.getUser(id).then(function (response) {
          return response;
        });
      };

      $scope.updateDisplayOther = function () {
        var index = $scope.appDenialReasons.denialReasons
          .map(function (i) {
            return i.id;
          })
          .indexOf(parseInt($scope.denyReason.denial_reason));
        $scope.showDenialReasonOther = false;
        if (index >= 0) {
          if ($scope.appDenialReasons.denialReasons[index].title == 'Other') {
            $scope.showDenialReasonOther = true;
          }
        }
      };

      $scope.goToMedia = function (id, app) {
        if (app === 'tigger') {
          $location.path('/media/edit/' + id);
        } else if (app === 'solensia') {
          $location.path('/experience-solensia/' + id);
        } else if (app === 'librela') {
          $location.path('/experience-librela/' + id);
        }
      };

      $scope.petVideos = MediaService.getMediaByPet(
        $routeParams.petId,
        $scope.order,
        $scope.mediaCategories,
        $scope.pageSize,
      ).then(function (response) {
        $scope.mediaFiles.solensia = response?.media?.filter((vid) => {
          return vid?.extra_data?.medication?.toLowerCase() === 'solensia';
        });
        $scope.mediaFiles.librela = response?.media?.filter((vid) => {
          return vid?.extra_data?.medication?.toLowerCase() === 'librela';
        });
        $scope.mediaFiles.cpiq = response?.media?.filter((vid) => {
          return vid?.extra_data?.job_id;
        });
      });
    },
  );
